module.exports = __webpack_public_path__ + "static/media/03.c4087b14.JPG";